import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconShoppingBag_5 = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.70473 12.2622C8.11215 12.1875 8.50299 12.4572 8.57768 12.8646L9.16446 16.0653H27.1553C27.3776 16.0653 27.5886 16.1639 27.7311 16.3347C27.8736 16.5054 27.9329 16.7306 27.8932 16.9494L25.9855 27.4417C25.9206 27.7983 25.61 28.0575 25.2476 28.0575H10.463C10.101 28.0575 9.79062 27.7989 9.72533 27.4427L7.10227 13.1351C7.02758 12.7277 7.29731 12.3369 7.70473 12.2622ZM9.43946 17.5653L11.088 26.5575H24.6216L26.2566 17.5653H9.43946Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 14.2788,
        cy: 32.3154,
        r: 1.66943,
        fill: "black"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 21.9097,
        cy: 32.3154,
        r: 1.66943,
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M36.5 14.75C36.5 19.0302 33.0302 22.5 28.75 22.5C24.4698 22.5 21 19.0302 21 14.75C21 10.4698 24.4698 7 28.75 7C33.0302 7 36.5 10.4698 36.5 14.75Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M28.8944 18.4846C30.5385 18.4846 31.6247 17.518 31.6247 16.0035C31.6247 14.4889 30.7378 13.6021 29.4425 13.6021C28.6354 13.6021 28.1372 13.9209 27.8582 14.2597L27.888 12.4761H31.1962V11.2505H26.6824L26.5827 15.306H27.4795C27.7685 14.9771 28.177 14.738 28.8446 14.738C29.562 14.738 30.0005 15.2163 30.0005 15.9835C30.0005 16.7408 29.6119 17.249 28.8845 17.249C28.0674 17.249 27.8283 16.8504 27.7386 16.2526H26.2539C26.3237 17.528 27.1407 18.4846 28.8944 18.4846Z",
        fill: "white"
    }));

export { IconShoppingBag_5 };
